import React, { useState } from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils";
import { CaButton } from "src/admin-panel";

export type ToggleButtonOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

type Props = {
  options: ToggleButtonOption[];
  onChange: (value: string) => void;
  value: string;
};

const bem = new BemHelper("toggle-button");

export const ToggleButton: React.FC<Props> = ({ onChange, options, value }) => {
  const [selected, setSelected] = useState<string>(value);

  function handleClick(value: string) {
    setSelected(value);
    onChange(value);
  }

  return (
    <div className={classNames(bem.block())}>
      {options.map(({ value, label, disabled }) => (
        <CaButton
          key={value}
          onClick={() => handleClick(value)}
          disabled={disabled}
          type='button'
          minimal={selected !== value}
          intent='secondary'
          size='small'
        >
          {label}
        </CaButton>
      ))}
    </div>
  );
};
